// @flow

import { primary, secondary, white, black, text } from 'theme/colors'

export default {
  common: {
    black,
    white,
    neutral: '#E4E7EB',
    muted: '#9EA0A4',
  },
  primary,
  secondary,
  text,
  background: {
    paper: '#fff',
    default: '#EEEEEE',
  },
}
